// frontend/src/config/api.ts
interface ApiConfig {
  baseURL: string;
  timeout: number;
  withCredentials: boolean;
  headers?: {
    'Content-Type'?: string;
    'X-Source'?: string;
  };
}

interface EnvironmentConfigs {
  development: ApiConfig;
  production: ApiConfig;
  test: ApiConfig;
  [key: string]: ApiConfig;
}

const config: EnvironmentConfigs = {
  development: {
    baseURL: 'http://localhost:3000/api',
    timeout: 10000,
    withCredentials: true
  },
  production: {
    baseURL: 'https://api.prayerbridge.io/api',
    timeout: 10000,
    withCredentials: true
  },
  test: {
    baseURL: 'http://localhost:3000/api',
    timeout: 2000,
    withCredentials: true
  }
};

// Get current environment
const environment = import.meta.env.MODE || 'development';

// Export config for current environment
export const apiConfig: ApiConfig = {
  ...config[environment],
  headers: {
    'Content-Type': 'application/json',
    // Add any environment-specific headers
    ...(environment === 'production' && {
      'X-Source': 'prayerbridge-web'
    })
  }
};

export default apiConfig;